import React from 'react';
import { LayerType } from '../../../types';
import { useMapCanvas } from '../contexts/MapCanvasContext';
import { DraggableShape } from '../shapes/DraggableShape/DraggableShape';
import { ShapeProvider } from '../shapes/ShapeContext/ShapeProvider';

export const useGetViewShapesByType = () => {
  const { shapes, gridSize, shapesInSelection } = useMapCanvas();

  const nothing = () => {};

  return (type: LayerType): React.ReactNode => {
    return shapes
      .filter((shape) => shape.layerType === type)
      .map((shape) => (
        <ShapeProvider
          key={shape.id}
          shape={shape}
          isSelected={false}
          isInSelection={shapesInSelection.includes(shape.id)}
          onSelect={nothing}
          onUpdate={nothing}
          snapToGrid={false}
          gridSize={gridSize}
          otherShapes={shapes}
          showSnapLines={false}
          disabled={false}
          isMultiSelected={false}
          onDelete={nothing}
          onLocate={nothing}
          onMoveUp={nothing}
          onMoveDown={nothing}
        >
          <DraggableShape key={shape.id} />
        </ShapeProvider>
      ));
  };
};
